interface InputData {
  captchaToken: string;
  country?: string;
  email: string;
  password: string;
  confirmEmail?: string;
}

export const formatInput = (inputData: InputData): InputData => {
  inputData.email = inputData.email.toLowerCase();
  if (inputData.confirmEmail) {
    inputData.confirmEmail = inputData.confirmEmail?.toLowerCase();
  }
  return inputData;
};
